import "./HandrulesButtons.css"
import requestHandler from "../../../utils/requestHandler";
import { UserAuth } from "../../../context/AuthContext";
import { useEffect, useState } from "react";
import lockIco from "../../../assets/icons/lock.svg"

const HandrulesButtons = ({token, editMode, lock}) => {
	const arr = ["T", "C", "R", "Q", "NT"];
	function addRule(type){
		if(editMode) {
			if(lock === type) {
				let myAuthToken = `Bearer ${token}`;
				let path = 'handrules/69/unlock';
				requestHandler(path, "POST", myAuthToken);
			} else {
				let myAuthToken = `Bearer ${token}`;
				let path = 'handrules/69/lock/' + type;
				requestHandler(path, "POST", myAuthToken);
				console.log(type);
			}
		} else {
			let myAuthToken = `Bearer ${token}`;
			let path = 'handrules/69/' + type;
			requestHandler(path, "POST", myAuthToken);
			console.log(type);
		}
	}

	function lockIcon() {
		return (<img className="lockIcon" src={lockIco} alt='locked'/>)
	}

	return (
		<div className="handrulesButtonsContainer">
			<div className="handrulesButton" id="firstButton" onClick={() => addRule("T")}>{arr.indexOf(lock) === 0 ? lockIcon() : "T"}</div>
			<div className="handrulesButton" onClick={() => addRule("C")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 1 ? lockIcon() : "C"}</div>
			<div className="handrulesButton" onClick={() => addRule("R")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 2 ? lockIcon() : "R"}</div>
			<div className="handrulesButton" onClick={() => addRule("Q")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 3 ? lockIcon() : "Q"}</div>
			<div className="handrulesButton" id="lastButton" onClick={() => addRule("NT")}>{arr.indexOf(lock) !== -1 && arr.indexOf(lock) <= 4 ? lockIcon() : "NT"}</div>
		</div>
	)
}

export default HandrulesButtons;